import { computed, getCurrentInstance, inject, onMounted, ref } from 'vue'
import { dictCache, dictCacheIndex } from '@/utils/util'
import type { TreeItem } from '@/types'
import { SELECTOR_MODAL } from '@/utils/constant'

export default function useSelector(list: TreeItem[], deep: number = 1) {
  const filterList = ref<string[]>([])
  const indexCache = computed(() => dictCacheIndex(list, deep))
  const labelCache = computed(() => dictCache(list, deep))
  const modal = inject(SELECTOR_MODAL)

  onMounted(() => {
    const inst = getCurrentInstance()
    if (inst) {
      modal?.mountChild?.(inst)
    }
  })

  function handleFilter(keywords: string) {
    filterList.value = Object.entries(labelCache.value)
      .filter(([value, label]) => label.indexOf(keywords) !== -1)
      .map(([value]) => indexCache.value[value])
  }

  return {
    indexCache,
    labelCache,
    filterList,
    handleFilter,
  }
}
